// extracted by mini-css-extract-plugin
var _1 = "tjs-notification-window__body";
var _2 = "tjs-notification-window__footer";
var _3 = "tjs-notification-window__inner tjs-_base__scrollbars";
var _4 = "tjs-notification-window__notification";
var _5 = "tjs-notification-window__title tjs-_base__h3";
var _6 = "tjs-notification-window__wrapper tjs-_base__flex";
export { _1 as "body", _2 as "footer", _3 as "inner", _4 as "notification", _5 as "title", _6 as "wrapper" }
export default { "body": _1, "footer": _2, "inner": _3, "notification": _4, "title": _5, "wrapper": _6 }
